import { z } from 'zod'

export const ADMINDESKTOPAGENTSPATCHGRANTS_CONTRACT_VERSION = '1.0.0' as const
export const adminDesktopAgentsPatchGrantsResponseSchema = z.unknown()
export type AdminDesktopAgentsPatchGrantsResponse = z.infer<typeof adminDesktopAgentsPatchGrantsResponseSchema>
